import { onError } from 'utils/handlers';
import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';

export const getTiposDeVisita = async () => {
  try {
    const response = await API.get('/tramites/tipos-de-visitas-domiciliarias/');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const getVisitaDomiciliaria = async (id) => {
  try {
    const response = await API.get(`/tramites/tipos-de-visitas-domiciliarias/${id}/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const createVisitaDomiciliaria = async (data) => {
  try {
    const response = await API.post('/tramites/tipos-de-visitas-domiciliarias/', data);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

export const updateVisitaDomiciliaria = async (id, data) => {
  try {
    const response = await API.patch(`/tramites/tipos-de-visitas-domiciliarias/${id}/`, data);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};
